<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="top_tance"></div>
    <div class="paddingContent">
      <div class="ListMenu">
        <el-form ref="form" class="searchForm">
          <el-form-item label="昵称:">
            <el-input v-model="nickname"></el-input>
          </el-form-item>

          <el-form-item label="状态:">
            <el-select v-model="isDel" placeholder="请选择">
              <el-option label="全部" value="1"></el-option>
              <el-option label="已禁言" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="MenuBtnWrap">
          <div class="btn" @click="exportLiveExcel">
            <img
              src="@/assets/images/common/exporticon.png"
              alt="暂无数据"
              :style="{
                width: '9px',
                height: '10px',
                marginLeft: '-5px',
                marginRight: '5px'
              }"
            />
            導出評論
          </div>
          <div class="btn" @click="search()">查詢</div>
          <div class="btn" @click="reset()">重置</div>
        </div>
      </div>

      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="commentList"
          v-if="!!commentList.length"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in commentTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <!-- <el-button @click="toEdit(scope.row.id)" type="text">修改</el-button> -->
              <el-button
                v-if="scope.row.isDel == '1'"
                @click="forbiddenView(scope.row.userId)"
                type="text"
                >禁言</el-button
              >
              <el-button
                v-else
                @click="forbiddenView(scope.row.userId)"
                type="text"
                >取消禁言</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="void_data" v-else>
          <img src="../../assets/images/common/icon_live_void.png" />
        </div>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "直播 / 直播管理",
      navtitle: "查看评论",
      commentList: [],
      commentTable: [
        {
          prop: "id",
          label: "评论id",
          width: ""
        },
        {
          prop: "username",
          label: "會員帳號",
          width: ""
        },
        {
          prop: "createUserName",
          label: "昵称",
          width: ""
        },
        {
          prop: "context",
          label: "评论内容",
          width: ""
        },
        {
          prop: "createTime",
          label: "发布时间",
          width: ""
        }
      ],
      id: this.$route.query.id,
      nickname: "",
      isDel: "1",
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false
    };
  },
  created() {
    this.getLiveComment();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取弹幕列表
    getLiveComment() {
      let param = {
        onLiveId: this.id,
        nickname: this.nickname,
        isDel: this.isDel == "1" ? "" : Number(this.isDel)
      };
      this.$post(
        `/bullet/chat/list?page=${this.currentPage - 1}&size=10`,
        param,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.total = res.data.total;
          res.data.list.forEach(v => {
            v.createTime = this.$getTime(v.createTime);
          });
          this.commentList = res.data.list;
          console.log(this.commentList);
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },

    //禁言/取消禁言
    forbiddenView(userId) {
      let _this = this;
      let param = {
        onLiveId: this.id,
        userId: userId
      };
      _this
        .$post(`/forbidden/user`, param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            let tips = res.data == false ? "解除禁言成功" : "禁言成功";
            _this.$propMessage(tips, "success", function() {
              _this.dialogVisible = false;
              _this.currentPage = 1;
              _this.getLiveComment();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    // 查询
    search() {
      // if (this.nickname === '') {
      //   this.$Mint.Toast('请至少输入一个搜索条件');
      //   return false;
      // }
      this.currentPage = 1;
      this.getLiveComment();
    },
    //重置
    reset() {
      this.nickname = "";
      this.isDel = "1";
      this.currentPage = 1;
      this.getLiveComment();
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getLiveComment();
    },
    exportLiveExcel() {
      let _this = this;
      let url = "/bullet/chat/excel/download";
      let param = {
        onLiveId: this.id,
        nickname: this.nickname,
        isDel: this.isDel == "1" ? "" : this.isDel
      };
      _this.$exportExcel(url, "POST", param, "直播评论");
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .top_tance {
    padding-top: 0.8rem;

    @media (max-width: 768px) {
      padding-top: 22px;
    }

    @media (max-width: 420px) {
      padding-top: 62px;
    }
  }

  .paddingContent {
    height: calc(100% - 88px);
    padding: 0.4rem 0.4rem;
    background-color: #ffffff;

    @media (max-width: 768px) {
      height: calc(100% - 62px);
    }

    .addBtn {
      margin: 0.2rem 0;
      cursor: pointer;

      @media (max-width: 420px) {
        margin-top: 0.3rem;
        margin-bottom: 10px;
      }
    }

    .btn {
      @media (max-width: 420px) {
        width: 1.3rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 12px;
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }

    .el-table {
      @media (max-width: 420px) {
        min-width: 200%;
      }
    }
  }

  .paging-block {
    margin: 0.2rem 0;

    @media (max-width: 420px) {
      margin: 0.3rem 0;
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .searchForm {
        flex: 1;
        display: flex;
        justify-content: flex-start;
      }
      .MenuBtnWrap {
        flex: 1;
      }
    }
  }
}
.tableWrap {
  position: relative;
}
.void_data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 244px;
  height: 139px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/live/liveComment.vue